import classNames from "classnames";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { IOperationLogsActivity, IOption } from "redux/app/vdmdashboard/@types";

const regionDropdownStyles = {
	dropdownIndicator:
		"p-1 hover:bg-gray-100 text-gray-500 rounded-md hover:text-black",
	menu: "p-1.5 py-1.5 mt-2 border border-gray-200 bg-white rounded-lg",
	option: {
		base: "hover:cursor-pointer px-2.5 py-1.5 rounded",
		focus: "bg-[#3182CE14] active:bg-gray-200 cursor-pointer",
		selected: "bg-blue-100 text-blue-800",
	},
	control: {
		base: "border rounded-md bg-white hover:cursor-pointer px-2 min-w-[180px]  min-h-[36px] h-[36px]",
		focus: "border-primary-600 ring-1 ring-primary-500",
		nonFocus: "border-gray-300 hover:border-gray-400",
		disabled: "bg-gray-200 cursor-not-allowed",
	},
};

type OwnProps = {
	row: IOperationLogsActivity;
};

function OperationLogsTableRow(props: OwnProps) {
	const { row } = props;
	const [region, setRegion] = useState<IOption | undefined>(undefined);

	useEffect(() => {
		setRegion({ label: row?.region, value: row?.region });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<tr key={row.activity} className="border-b last:border-0">
			<td className="px-3 py-2 text-sm whitespace-nowrap font-medium">
				<div className="flex items-center">
					<span>{row.activity}</span>
					{typeof row?.details?.qty === "number" ? (
						<div className="bg-blue-100 border-blue-400 border rounded-full ml-1.5 px-1.5 text-blue-500 text-[12px]">
							{row?.details?.boatName ? (
								<div className="flex items-center gap-x-1">
									<span>{row?.details?.boatName}</span>
									<span className="inline-block w-1 h-1 rounded-full bg-blue-500" />
									<span>Qty : {row?.details?.qty}</span>
								</div>
							) : (
								<span>Qty : {row?.details?.qty}</span>
							)}
						</div>
					) : null}
				</div>
			</td>
			<td className="px-3 py-2 text-sm whitespace-nowrap">
				<Select<IOption>
					id="region"
					isSearchable
					key={"region" + region?.value}
					placeholder={"Search Vessels"}
					value={region}
					unstyled
					options={[
						{ label: "MV - Lake Quraoun", value: "MV - Lake Quraoun" },
						{ label: "MV - CGMA CMA", value: "MV - CGMA CMA" },
					]}
					onChange={(newValue, actionMeta) => {
						if (newValue?.value) {
							setRegion(newValue);
						}
					}}
					className={classNames("w-full text-sm", {
						"cursor-not-allowed": false,
					})}
					menuPosition="fixed"
					classNames={{
						dropdownIndicator: () => regionDropdownStyles.dropdownIndicator,
						menu: () => regionDropdownStyles.menu,
						option: ({ isFocused, isSelected }: any) =>
							clsx(
								isFocused && regionDropdownStyles.option.focus,
								isSelected && regionDropdownStyles.option.selected,
								regionDropdownStyles.option.base
							),

						control: ({ isFocused, isDisabled }) =>
							clsx(
								regionDropdownStyles.control.base,
								isFocused
									? regionDropdownStyles.control.focus
									: regionDropdownStyles.control.nonFocus,
								isDisabled
									? regionDropdownStyles.control.disabled
									: regionDropdownStyles.control.base
							),
						indicatorsContainer: () => "h-[36px]",
						valueContainer: ({ isDisabled }) =>
							clsx(
								"px-3 text-gray-800 font-medium",
								isDisabled && "bg-gray-100 ml-2"
							),
					}}
				/>
			</td>
			<td className="px-3 py-2 text-sm whitespace-nowrap">
				{row.inTime} - {row.outTime}
			</td>
			<td className="px-3 py-2 text-sm whitespace-nowrap font-medium">
				{row.vendor}
			</td>
			<td className="px-3 py-2 text-sm whitespace-wrap">
				<span className="block">
					Last reported at:{" "}
					<span className="font-medium">{row?.reporting?.lastReportedAt}</span>
				</span>
				<span className="block">
					Reported by:{" "}
					<span className="font-medium">{row?.reporting?.reportedBy}</span>
				</span>
			</td>
		</tr>
	);
}

export default OperationLogsTableRow;
